import { useSecureImage } from '../hooks/useSecureImage';

interface SecureImageProps {
  url: string;
  alt: string;
  className?: string;
  fallback?: React.ReactNode;
}

export function SecureImage({ url, alt, className = '', fallback }: SecureImageProps) {
  const { imageUrl, loading, error } = useSecureImage(url);

  // Show loading state
  if (loading) {
    return <div className={`bg-gray-600 animate-pulse ${className}`}></div>;
  }

  // Show error or fallback
  if (error || !imageUrl) {
    return fallback ? (
      <>{fallback}</>
    ) : (
      <div className={`bg-gray-600 flex items-center justify-center ${className}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-gray-400"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <circle cx="8.5" cy="8.5" r="1.5"></circle>
          <polyline points="21 15 16 10 5 21"></polyline>
        </svg>
      </div>
    );
  }

  // Show image
  return <img src={imageUrl} alt={alt} className={className} />;
}
